/**
 * ISO 3166-1 country codes -> localized display names, generated once from
 * i18n-iso-countries (select: "official"). Static and committed rather than a runtime
 * dependency: country names/codes are effectively immutable, and this sidesteps a real
 * cross-bundler issue -- the package has no "exports" map, so Vite resolves its "browser"
 * field (empty locale registry, requires manual registerLocale calls) while Node resolves
 * "main" (auto-registers every locale) -- the same import would behave differently in the
 * web app vs. the backend. A static object has no such ambiguity.
 */

export const COUNTRY_NAMES_EN: Record<string, string> = {
  AD: 'Andorra',
  AE: 'United Arab Emirates',
  AF: 'Afghanistan',
  AG: 'Antigua and Barbuda',
  AI: 'Anguilla',
  AL: 'Albania',
  AM: 'Armenia',
  AO: 'Angola',
  AQ: 'Antarctica',
  AR: 'Argentina',
  AS: 'American Samoa',
  AT: 'Austria',
  AU: 'Australia',
  AW: 'Aruba',
  AX: 'Åland Islands',
  AZ: 'Azerbaijan',
  BA: 'Bosnia and Herzegovina',
  BB: 'Barbados',
  BD: 'Bangladesh',
  BE: 'Belgium',
  BF: 'Burkina Faso',
  BG: 'Bulgaria',
  BH: 'Bahrain',
  BI: 'Burundi',
  BJ: 'Benin',
  BL: 'Saint Barthélemy',
  BM: 'Bermuda',
  BN: 'Brunei Darussalam',
  BO: 'Bolivia',
  BQ: 'Bonaire, Sint Eustatius and Saba',
  BR: 'Brazil',
  BS: 'Bahamas',
  BT: 'Bhutan',
  BV: 'Bouvet Island',
  BW: 'Botswana',
  BY: 'Belarus',
  BZ: 'Belize',
  CA: 'Canada',
  CC: 'Cocos (Keeling) Islands',
  CD: 'Democratic Republic of the Congo',
  CF: 'Central African Republic',
  CG: 'Republic of the Congo',
  CH: 'Switzerland',
  CI: "Cote d'Ivoire",
  CK: 'Cook Islands',
  CL: 'Chile',
  CM: 'Cameroon',
  CN: "People's Republic of China",
  CO: 'Colombia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  CV: 'Cape Verde',
  CW: 'Curaçao',
  CX: 'Christmas Island',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DE: 'Germany',
  DJ: 'Djibouti',
  DK: 'Denmark',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  DZ: 'Algeria',
  EC: 'Ecuador',
  EE: 'Estonia',
  EG: 'Egypt',
  EH: 'Western Sahara',
  ER: 'Eritrea',
  ES: 'Spain',
  ET: 'Ethiopia',
  FI: 'Finland',
  FJ: 'Fiji',
  FK: 'Falkland Islands (Malvinas)',
  FM: 'Micronesia, Federated States of',
  FO: 'Faroe Islands',
  FR: 'France',
  GA: 'Gabon',
  GB: 'United Kingdom',
  GD: 'Grenada',
  GE: 'Georgia',
  GF: 'French Guiana',
  GG: 'Guernsey',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GL: 'Greenland',
  GM: 'Republic of The Gambia',
  GN: 'Guinea',
  GP: 'Guadeloupe',
  GQ: 'Equatorial Guinea',
  GR: 'Greece',
  GS: 'South Georgia and the South Sandwich Islands',
  GT: 'Guatemala',
  GU: 'Guam',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HK: 'Hong Kong',
  HM: 'Heard Island and McDonald Islands',
  HN: 'Honduras',
  HR: 'Croatia',
  HT: 'Haiti',
  HU: 'Hungary',
  ID: 'Indonesia',
  IE: 'Ireland',
  IL: 'Israel',
  IM: 'Isle of Man',
  IN: 'India',
  IO: 'British Indian Ocean Territory',
  IQ: 'Iraq',
  IR: 'Islamic Republic of Iran',
  IS: 'Iceland',
  IT: 'Italy',
  JE: 'Jersey',
  JM: 'Jamaica',
  JO: 'Jordan',
  JP: 'Japan',
  KE: 'Kenya',
  KG: 'Kyrgyzstan',
  KH: 'Cambodia',
  KI: 'Kiribati',
  KM: 'Comoros',
  KN: 'Saint Kitts and Nevis',
  KP: 'North Korea',
  KR: 'South Korea',
  KW: 'Kuwait',
  KY: 'Cayman Islands',
  KZ: 'Kazakhstan',
  LA: "Lao People's Democratic Republic",
  LB: 'Lebanon',
  LC: 'Saint Lucia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  LV: 'Latvia',
  LY: 'Libya',
  MA: 'Morocco',
  MC: 'Monaco',
  MD: 'Moldova, Republic of',
  ME: 'Montenegro',
  MF: 'Saint Martin (French part)',
  MG: 'Madagascar',
  MH: 'Marshall Islands',
  MK: 'The Republic of North Macedonia',
  ML: 'Mali',
  MM: 'Myanmar',
  MN: 'Mongolia',
  MO: 'Macao',
  MP: 'Northern Mariana Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Mauritius',
  MV: 'Maldives',
  MW: 'Malawi',
  MX: 'Mexico',
  MY: 'Malaysia',
  MZ: 'Mozambique',
  NA: 'Namibia',
  NC: 'New Caledonia',
  NE: 'Niger',
  NF: 'Norfolk Island',
  NG: 'Nigeria',
  NI: 'Nicaragua',
  NL: 'Netherlands',
  NO: 'Norway',
  NP: 'Nepal',
  NR: 'Nauru',
  NU: 'Niue',
  NZ: 'New Zealand',
  OM: 'Oman',
  PA: 'Panama',
  PE: 'Peru',
  PF: 'French Polynesia',
  PG: 'Papua New Guinea',
  PH: 'Philippines',
  PK: 'Pakistan',
  PL: 'Poland',
  PM: 'Saint Pierre and Miquelon',
  PN: 'Pitcairn',
  PR: 'Puerto Rico',
  PS: 'State of Palestine',
  PT: 'Portugal',
  PW: 'Palau',
  PY: 'Paraguay',
  QA: 'Qatar',
  RE: 'Reunion',
  RO: 'Romania',
  RS: 'Serbia',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  SA: 'Saudi Arabia',
  SB: 'Solomon Islands',
  SC: 'Seychelles',
  SD: 'Sudan',
  SE: 'Sweden',
  SG: 'Singapore',
  SH: 'Saint Helena',
  SI: 'Slovenia',
  SJ: 'Svalbard and Jan Mayen',
  SK: 'Slovakia',
  SL: 'Sierra Leone',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somalia',
  SR: 'Suriname',
  SS: 'South Sudan',
  ST: 'Sao Tome and Principe',
  SV: 'El Salvador',
  SX: 'Sint Maarten (Dutch part)',
  SY: 'Syrian Arab Republic',
  SZ: 'Eswatini',
  TC: 'Turks and Caicos Islands',
  TD: 'Chad',
  TF: 'French Southern Territories',
  TG: 'Togo',
  TH: 'Thailand',
  TJ: 'Tajikistan',
  TK: 'Tokelau',
  TL: 'Timor-Leste',
  TM: 'Turkmenistan',
  TN: 'Tunisia',
  TO: 'Tonga',
  TR: 'Türkiye',
  TT: 'Trinidad and Tobago',
  TV: 'Tuvalu',
  TW: 'Taiwan, Province of China',
  TZ: 'United Republic of Tanzania',
  UA: 'Ukraine',
  UG: 'Uganda',
  UM: 'United States Minor Outlying Islands',
  US: 'United States of America',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VA: 'Holy See (Vatican City State)',
  VC: 'Saint Vincent and the Grenadines',
  VE: 'Venezuela',
  VG: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  VN: 'Vietnam',
  VU: 'Vanuatu',
  WF: 'Wallis and Futuna',
  WS: 'Samoa',
  XK: 'Kosovo',
  YE: 'Yemen',
  YT: 'Mayotte',
  ZA: 'South Africa',
  ZM: 'Zambia',
  ZW: 'Zimbabwe'
};

export const COUNTRY_NAMES_HE: Record<string, string> = {
  AD: 'אנדורה',
  AE: 'איחוד האמירויות הערביות',
  AF: 'אפגניסטן',
  AG: 'אנטיגואה וברבודה',
  AI: 'אנגילה',
  AL: 'אלבניה',
  AM: 'ארמניה',
  AO: 'אנגולה',
  AQ: 'אנטארקטיקה',
  AR: 'ארגנטינה',
  AS: 'סמואה האמריקנית',
  AT: 'אוסטריה',
  AU: 'אוסטרליה',
  AW: 'ארובה',
  AX: 'איי אולנד',
  AZ: 'אזרבייג׳ן',
  BA: 'בוסניה והרצגובינה',
  BB: 'ברבדוס',
  BD: 'בנגלדש',
  BE: 'בלגיה',
  BF: 'בורקינה פאסו',
  BG: 'בולגריה',
  BH: 'בחריין',
  BI: 'בורונדי',
  BJ: 'בנין',
  BL: 'סנט ברתולומיאו',
  BM: 'ברמודה',
  BN: 'ברוניי',
  BO: 'בוליביה',
  BQ: 'האיים הקריביים ההולנדיים',
  BR: 'ברזיל',
  BS: 'איי בהאמה',
  BT: 'בהוטן',
  BV: 'איי בובה',
  BW: 'בוצוואנה',
  BY: 'בלארוס',
  BZ: 'בליז',
  CA: 'קנדה',
  CC: 'איי קוקוס (קילינג)',
  CD: 'קונגו - קינשאסה',
  CF: 'הרפובליקה של מרכז אפריקה',
  CG: 'קונגו - ברזאויל',
  CH: 'שווייץ',
  CI: 'חוף השנהב',
  CK: 'איי קוק',
  CL: 'צ׳ילה',
  CM: 'קמרון',
  CN: 'סין',
  CO: 'קולומביה',
  CR: 'קוסטה ריקה',
  CU: 'קובה',
  CV: 'כף ורדה',
  CW: 'קוראסאו',
  CX: 'האי כריסטמס',
  CY: 'קפריסין',
  CZ: 'צ׳כיה',
  DE: 'גרמניה',
  DJ: 'ג׳יבוטי',
  DK: 'דנמרק',
  DM: 'דומיניקה',
  DO: 'הרפובליקה הדומיניקנית',
  DZ: 'אלג׳יריה',
  EC: 'אקוודור',
  EE: 'אסטוניה',
  EG: 'מצרים',
  EH: 'סהרה המערבית',
  ER: 'אריתריאה',
  ES: 'ספרד',
  ET: 'אתיופיה',
  FI: 'פינלנד',
  FJ: 'פיג׳י',
  FK: 'איי פוקלנד',
  FM: 'מיקרונזיה',
  FO: 'איי פארו',
  FR: 'צרפת',
  GA: 'גבון',
  GB: 'הממלכה המאוחדת',
  GD: 'גרנדה',
  GE: 'גאורגיה',
  GF: 'גיאנה הצרפתית',
  GG: 'גרנסי',
  GH: 'גאנה',
  GI: 'גיברלטר',
  GL: 'גרינלנד',
  GM: 'גמביה',
  GN: 'גינאה',
  GP: 'גוואדלופ',
  GQ: 'גינאה המשוונית',
  GR: 'יוון',
  GS: 'ג׳ורג׳יה הדרומית ואיי סנדוויץ׳ הדרומיים',
  GT: 'גואטמלה',
  GU: 'גואם',
  GW: 'גינאה ביסאו',
  GY: 'גיאנה',
  HK: 'הונג קונג (מחוז מנהלי מיוחד של סין)',
  HM: 'איי הרד ומקדונלד',
  HN: 'הונדורס',
  HR: 'קרואטיה',
  HT: 'האיטי',
  HU: 'הונגריה',
  ID: 'אינדונזיה',
  IE: 'אירלנד',
  IL: 'ישראל',
  IM: 'האי מאן',
  IN: 'הודו',
  IO: 'הטריטוריה הבריטית באוקיינוס ההודי',
  IQ: 'עיראק',
  IR: 'איראן',
  IS: 'איסלנד',
  IT: 'איטליה',
  JE: 'ג׳רסי',
  JM: 'ג׳מייקה',
  JO: 'ירדן',
  JP: 'יפן',
  KE: 'קניה',
  KG: 'קירגיזסטן',
  KH: 'קמבודיה',
  KI: 'קיריבאטי',
  KM: 'קומורו',
  KN: 'סנט קיטס ונוויס',
  KP: 'קוריאה הצפונית',
  KR: 'קוריאה הדרומית',
  KW: 'כווית',
  KY: 'איי קיימן',
  KZ: 'קזחסטן',
  LA: 'לאוס',
  LB: 'לבנון',
  LC: 'סנט לוסיה',
  LI: 'ליכטנשטיין',
  LK: 'סרי לנקה',
  LR: 'ליבריה',
  LS: 'לסוטו',
  LT: 'ליטא',
  LU: 'לוקסמבורג',
  LV: 'לטביה',
  LY: 'לוב',
  MA: 'מרוקו',
  MC: 'מונקו',
  MD: 'מולדובה',
  ME: 'מונטנגרו',
  MF: 'סן מרטן',
  MG: 'מדגסקר',
  MH: 'איי מרשל',
  MK: 'מקדוניה הצפונית',
  ML: 'מאלי',
  MM: 'מיאנמר (בורמה)',
  MN: 'מונגוליה',
  MO: 'מקאו (מחוז מנהלי מיוחד של סין)',
  MP: 'איי מריאנה הצפוניים',
  MQ: 'מרטיניק',
  MR: 'מאוריטניה',
  MS: 'מונסראט',
  MT: 'מלטה',
  MU: 'מאוריציוס',
  MV: 'האיים המלדיביים',
  MW: 'מלאווי',
  MX: 'מקסיקו',
  MY: 'מלזיה',
  MZ: 'מוזמביק',
  NA: 'נמיביה',
  NC: 'קלדוניה החדשה',
  NE: 'ניז׳ר',
  NF: 'איי נורפוק',
  NG: 'ניגריה',
  NI: 'ניקרגואה',
  NL: 'הולנד',
  NO: 'נורווגיה',
  NP: 'נפאל',
  NR: 'נאורו',
  NU: 'ניווה',
  NZ: 'ניו זילנד',
  OM: 'עומאן',
  PA: 'פנמה',
  PE: 'פרו',
  PF: 'פולינזיה הצרפתית',
  PG: 'פפואה גינאה החדשה',
  PH: 'הפיליפינים',
  PK: 'פקיסטן',
  PL: 'פולין',
  PM: 'סנט פייר ומיקלון',
  PN: 'איי פיטקרן',
  PR: 'פוארטו ריקו',
  PS: 'השטחים הפלסטיניים',
  PT: 'פורטוגל',
  PW: 'פלאו',
  PY: 'פרגוואי',
  QA: 'קטאר',
  RE: 'ראוניון',
  RO: 'רומניה',
  RS: 'סרביה',
  RU: 'רוסיה',
  RW: 'רואנדה',
  SA: 'ערב הסעודית',
  SB: 'איי שלמה',
  SC: 'איי סיישל',
  SD: 'סודן',
  SE: 'שוודיה',
  SG: 'סינגפור',
  SH: 'סנט הלנה',
  SI: 'סלובניה',
  SJ: 'סוולבארד ויאן מאיין',
  SK: 'סלובקיה',
  SL: 'סיירה לאונה',
  SM: 'סן מרינו',
  SN: 'סנגל',
  SO: 'סומליה',
  SR: 'סורינם',
  SS: 'דרום סודן',
  ST: 'סאו טומה ופרינסיפה',
  SV: 'אל סלבדור',
  SX: 'סנט מארטן',
  SY: 'סוריה',
  SZ: 'סווזילנד',
  TC: 'איי טורקס וקאיקוס',
  TD: 'צ׳אד',
  TF: 'הטריטוריות הדרומיות של צרפת',
  TG: 'טוגו',
  TH: 'תאילנד',
  TJ: 'טג׳יקיסטן',
  TK: 'טוקלאו',
  TL: 'טימור לסטה',
  TM: 'טורקמניסטן',
  TN: 'טוניסיה',
  TO: 'טונגה',
  TR: 'טורקיה',
  TT: 'טרינידד וטובגו',
  TV: 'טובאלו',
  TW: 'טייוואן',
  TZ: 'טנזניה',
  UA: 'אוקראינה',
  UG: 'אוגנדה',
  UM: 'האיים המרוחקים הקטנים של ארה״ב',
  US: 'ארצות הברית',
  UY: 'אורוגוואי',
  UZ: 'אוזבקיסטן',
  VA: 'הוותיקן',
  VC: 'סנט וינסנט והגרנדינים',
  VE: 'ונצואלה',
  VG: 'איי הבתולה הבריטיים',
  VI: 'איי הבתולה של ארצות הברית',
  VN: 'וייטנאם',
  VU: 'ונואטו',
  WF: 'איי ווליס ופוטונה',
  WS: 'סמואה',
  XK: 'קוסובו',
  YE: 'תימן',
  YT: 'מאיוט',
  ZA: 'דרום אפריקה',
  ZM: 'זמביה',
  ZW: 'זימבבואה'
};
